import axios from "axios";
import { method } from "lodash";

export default {
  getBulkReport({ commit }, list) {
    return axios({
      // url: "/bulk/report",
      url: "/bulk/list",
      method: "GET",
      params: {
        per_page: list.per_page || 10,
        started_at_gt: list.start_time || null,
        finished_at_lt: list.end_time || null,
        page: list.page || 0,
        text: list.text ? `${list.text}*` : null,
        order_by: list.order_by || '',
        order_dir: list.order_dir || ''
      }
    }).then(res => {
      const { items: bulkReport, total, per_page } = res.data.payload;
      commit('SET_BULK_REPORT', { bulkReport, total, per_page });
      return res.data.payload;
    });
  },

  getBulkAutoSubstitutingReport({ commit }, list) {
      return axios({
        url: "/bulk_random/list",
        method: "GET",
        params: {
          per_page: list.per_page || 10,
          started_at_gt: list.start_time || null,
          finished_at_lt: list.end_time || null,
          page: list.page || 0,
          text: list.text ? `${list.text}*` : null,
          order_by: list.order_by || '',
          order_dir: list.order_dir || '',
          company_uuid: list.company_uuid || ''
        }
      }).then(res => {
      const { items: bulkAutoSubstitutingReport, total, per_page } = res.data.payload;
      commit('SET_BULK_AUTO_SUBSTITUTING_REPORT', { bulkAutoSubstitutingReport, total, per_page });
      return res.data.payload;
    });
  },
  getBulkSms({ commit }, list) {
      return axios({
        url: "/bulk_sms/list",
        method: "GET",
        params: {
          per_page: list.per_page || 10,
          started_at_gt: list.start_time || null,
          finished_at_lt: list.end_time || null,
          page: list.page || 0,
          text: list.text ? `${list.text}*` : null,
          order_by: list.order_by || '',
          order_dir: list.order_dir || '',
          company_uuid: list.company_uuid || ''
        }
      }).then(res => {
      const { items: bulkSms, total, per_page } = res.data.payload;
      commit('SET_BULK_SMS', { bulkSms, total, per_page });
      return res.data.payload;
    });
  },
  getBulkNumbers({ commit }, list) {
    return axios({
      url: `/bulk/${list.id}/report${list.status ? `?route_status=${list.status}` : ''}`,
      method: "GET",
      bulk_uuid: list.id || null,
      route_status: list.status || ''
    }).then(res => {
      return res.data.payload
    })
  },
  bulkRun({ commit }, list) {
    return axios({
      url: `/bulk/${list.bulk_uuid}/run`,
      method: 'POST',
    })
      .then(res => {
        return res
      })
      .catch(err => {
        return err
      })
  },
  bulkStop({ commit }, list) {
    return axios({
      url: `/bulk/${list.bulk_uuid}/hold`,
      method: 'POST',
    })
  },
}